export const ApiError = () => {
    return (
        <div class="px-4 py-5 my-5 text-center">
            <h1 class="display-5 fw-bold">Error querying API</h1>
            <p class="lead mb-4">There was an error querying the API for status. You can refresh your browser to try again.</p>
            <p class="lead mb-4">If the problem continues please contact ICT <strong><a href="mailto:ict-linux-platform@mail.ufl.edu?cc=ufit-ict-cloud-enablement@mail.ufl.edu&subject=OneWiki start/stop API failure">here</a></strong></p>
        </div >
    )
}